export default {
  title: 'Pago exitoso',
  description:
    '¡Muchas gracias por aliarte a SOSAFE! Recibirás un correo electrónico de confirmación de pago y otro con el enlace para poder ingresar al portal donde podrás ver el dashboard con las métricas de tu anuncio.<br/><br/>Revisaremos la información brindada y te contactaremos en el transcurso de los próximos días.<br/>No dudes escribirnos a <0>{{contactEmail}}</0> por cualquier duda o consulta.',
};
